import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { finalize, Subject } from 'rxjs';
import { SpinnerService } from 'src/app/components/spinner/spinner.service';
import { LANGUAGES } from 'src/app/constants/lang';
import { Flux, FluxService } from 'src/app/service/flux-service';
import { BookedEvent } from 'src/app/model/event.model';
import { ReservationSummary } from 'src/app/model/reservation.model';
import { ROUTES } from 'src/app/route/routes';
import { BookingService } from 'src/app/service/booking.service';
import { HomeService } from 'src/app/service/home.service';
import { UserService } from 'src/app/service/user.service';

@Component({
  selector: 'app-handle-reservations',
  templateUrl: './handle-reservations.component.html',
  styleUrls: ['./handle-reservations.component.scss'],
  standalone: false
})
export class HandleReservationsComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  flux: Flux = 'spa';
  hasEvents: boolean = false;

  eventsList: Array<BookedEvent> = new Array<BookedEvent>();

  private uuid_selected_reservation: any;
  userLanguage: string;
  public languages = LANGUAGES;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private spinner: SpinnerService,
    private homeService: HomeService,
    private bookingService: BookingService,
    private dialog: MatDialog,
    public auth: UserService,
    private userService: UserService,
    private translate: TranslateService,
    private fluxService: FluxService
  ) {}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit(): void {
    this.spinner.show();
    this.userLanguage = this.userService.lang;
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.userLanguage = event.lang;
    });

    this.fluxService.initializeFromRoute(this.route);
    this.flux = this.fluxService.getCurrentFlux();

    this.bookingService
      .getAssociatedReservations(this.flux)
      .pipe(
        finalize(() => {
          this.spinner.hide();
        })
      )
      .subscribe({
        next: (res) => {
          if (res && res instanceof Array) {
            res.forEach((el) => {
              let ev = new BookedEvent(
                el.uuid_event,
                el.event_name,
                el.event_short_description,
                el.event_long_description,
                el.event_category_name,
                el.event_category_url,
                el.event_location
              );
              let reservations: any[] = el.associated_reservations;
              reservations.forEach((el2) => {
                let summary = new ReservationSummary(
                  el2.uuid_reservation,
                  el2.uuid_passenger,
                  el2.uuid_employee,
                  el2.display_name,
                  el2.badge_number,
                  el2.creation_datetime,
                  el2.event_occurrence_datetime,
                  el2.ticket_datetime,
                  el2.ticket_file_name,
                  el2.number_of_users,
                  el2.uuid_event_occurrence,
                  el2.event_dates,
                  el2.is_editable,
                  el2.is_waiting_list
                );

                ev.associated_reservations.push(summary);
              });

              this.eventsList.push(ev);
            });
          }

          this.hasEvents = this.eventsList.length != 0;
        },
        error: (err) => {
          this.spinner.hide();
        },
      });
  }

  eventSelected(event: BookedEvent) {
    const currentFlux = this.fluxService.getCurrentFlux();
    this.homeService.saveReservationObject(event);
    this.router.navigate([currentFlux + '/' + ROUTES.RESERVATION.path]);

    // const dialogRef = this.dialog.open(EventReservationsComponent, {
    //   data: {
    //     event_name: event.event_name,
    //     event_long_description: event.event_long_description,
    //     associated_reservations: event.associated_reservations,
    //   },
    // });

    // dialogRef.afterClosed().subscribe((result: ReservationSummary) => {
    //   if (result) {
    //     let newEvent: Event = new Event(
    //       event.uuid_event,
    //       event.event_name,
    //       event.event_location,
    //       event.event_short_description,
    //       event.event_long_description,
    //       result.event_dates,
    //       result.is_waiting_list!
    //     );
    //     this.homeService.saveEventObject(newEvent);

    //     let mockProfile: Profile = new Profile(
    //       result.displayName,
    //       result.badgeNumber,
    //       true,
    //       true,
    //       result.uuid_passenger,
    //       result.uuid_employee
    //     );
    //     this.homeService.saveProfileObject([mockProfile]);

    //     let oldReservation: ExistingReservation = {
    //       uuid_old_reservation: result.uuid_reservation,
    //       old_number_of_users: result.number_of_users,
    //       uuid_old_event_occurrence: result.uuid_event_occurrence,
    //     };
    //     this.homeService.saveEditReservationObject(oldReservation);

    //     this.route.navigate([ROUTES.EVENT_EDIT.path]);
    //   }
    // });
  }

  editReservation(reservation: any) {
    this.uuid_selected_reservation = reservation.uuid_reservation;
    this.goTo('edit');
  }

  goTo(path: string) {
    const currentFlux = this.fluxService.getCurrentFlux();
    switch (path) {
      case 'edit': {
        let idReservation = this.uuid_selected_reservation;
        this.router.navigate([
          currentFlux + '/' + ROUTES.EVENT_EDIT.path,
          { idReservation },
        ]);
        break;
      }

      case 'home': {
        this.router.navigate([ROUTES.HOME.path]);
        break;
      }
    }
  }
}
